var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.109,
    height: 50,
    viewBox: "0 0 53.109 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9008",
    "data-name": "Group 9008",
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 53.109,
    height: 50,
    rx: 10,
    transform: "translate(0.5 0.5)",
    fill: "#05ce78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "send-1-svgrepo-com",
    d: "M19.142,8.9,9.971,4.316c-6.161-3.086-8.689-.557-5.6,5.6L5.3,11.784a1.952,1.952,0,0,1,0,1.725l-.932,1.854c-3.086,6.161-.568,8.689,5.6,5.6l9.172-4.586C23.257,14.324,23.257,10.959,19.142,8.9Zm-3.461,4.543H9.9a.8.8,0,0,1,0-1.607h5.786a.8.8,0,0,1,0,1.607Z",
    transform: "translate(13.451 12.5)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendicon);
export default __webpack_public_path__ + "static/media/sendicon.6bfbe86be493b4af27006fe86cada194.svg";
export { ForwardRef as ReactComponent };